<template>
  <section class="hero is-light is-fullheight">
    <Navbar />
    <Alert />
    <div class="hero-body pt-2">
      <router-view />
    </div>

    <!--	<Loading />-->
    <img
      src="/assets/logos/sectigo_trust_seal.png"
      style="width: 128px; position: fixed; bottom: 10px; right: 10px"
    />
    <div class="footer-links" style="position: fixed; bottom: 10px; left: 10px; font-size: 14px;">
      <router-link to="/privacy-policy" class="mr-3">Privacy Policy</router-link> |
      <router-link to="/terms" class="mx-3">Terms & Conditions</router-link> |
      <router-link to="/credits" class="ml-3">Credits</router-link>
    </div>
  </section>
</template>

<script>
import Navbar from './components/Navbar';
import Loading from './components/Loading';
import Alert from './components/Alert.vue';

export default {
  components: {
    Navbar,
    Loading,
    Alert,
  },
};
</script>
